import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import '../components/style.css';
import schoolImage from "../assets/images/grand_school.jpg";
import mainLogo from "../assets/images/vedgurukul_logo.jpg";
import CryptoJS from "crypto-js";
import loadingspinner from '../assets/images/loading.jpg.gif'


const DB_NAME = 'SchoolManagementDB';
const STUDENT_STORE = 'studentData';
const SCHOOL_STORE = 'schoolData';
const ATTENDANCE_STORE = 'attendance';
const DEFAULTSETTING_STORE = 'defaultSettings';
const INVENTORY_STORE = 'inventory';
const LEAVING_CERTIFICATE_STORE = 'leavedStd';
const BONAFIDE_CERTIFICATE_STORE = 'bonafideStd';
const KIRD_STORE = 'kirdWithFeeattach';
const DB_VERSION = 1;


function LoginForm() {
  const [mobileNumber, setMobileNumber] = useState('');
  const [password, setPassword] = useState('');
  const [udiseNumber, setUdiseNumber] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [language, setschoollanguage] = useState(localStorage.getItem('language') || 'English');
  const [schoolName, setSchoolName] = useState('');
  const [schoolLogo, setSchoolLogo] = useState('');
  const navigate = useNavigate();
  const [udiseOptions, setUdiseOptions] = useState([]);
  const [savingData, setSavingData] = useState(false);


  const [department, setDepartment] = useState('');
  const [departmentOptions, setDepartmentOptions] = useState([]);

  useEffect(() => {
    // Proactively check if browser has a conflicting higher version of SchoolManagementDB
    if (typeof window !== 'undefined' && window.indexedDB && window.indexedDB.databases) {
      window.indexedDB.databases().then((dbs) => {
        const dbInfo = dbs.find((d) => d.name === DB_NAME);
        if (dbInfo && dbInfo.version && dbInfo.version > DB_VERSION) {
          console.warn(`Detected ${DB_NAME} version ${dbInfo.version} > ${DB_VERSION}. Deleting conflicting database...`);
          window.indexedDB.deleteDatabase(DB_NAME);
        }
      }).catch((e) => {
        console.warn("Could not query indexedDB.databases:", e);
      });
    }
  }, []);


  const normalizeUdise = (udise) => {
    return String(udise).trim();
  };

  const normalizeClassName = (firebaseClassKey) => {
    if (!firebaseClassKey || typeof firebaseClassKey !== 'string') return '';

    let str = firebaseClassKey.trim().toUpperCase();

    // Remove common prefixes
    str = str.replace(/^(CLASS|STD|SECTION|इयत्ता|इ\.)\s*/i, '').trim();
    // Remove common suffixes
    str = str.replace(/\s*(CLASS|STD)$/i, '').trim();

    // Comprehensive mapping for Roman numerals, Marathi names, Ordinals, and Digits
    const classMapping = {
      // 1st / Class 1 / Class I / Marathi
      '1': '1', '1ST': '1', 'FIRST': '1', 'I': '1', 'पहिली': '1', '१': '1', '१ ली': '1', '1 ली': '1', '1ST STD': '1',
      // 2nd / Class 2 / Class II / Marathi
      '2': '2', '2ND': '2', 'SECOND': '2', 'II': '2', 'दुसरी': '2', '२': '2', '२ री': '2', '2 री': '2', '2ND STD': '2',
      // 3rd / Class 3 / Class III / Marathi
      '3': '3', '3RD': '3', 'THIRD': '3', 'III': '3', 'तिसरी': '3', '३': '3', '३ री': '3', '3 री': '3', '3RD STD': '3',
      // 4th / Class 4 / Class IV / Marathi
      '4': '4', '4TH': '4', 'FOURTH': '4', 'IV': '4', 'चौथी': '4', '४': '4', '४ थी': '4', '4 थी': '4', '4TH STD': '4',
      // 5th / Class 5 / Class V / Marathi
      '5': '5', '5TH': '5', 'FIFTH': '5', 'V': '5', 'पाचवी': '5', '५': '5', '५ वी': '5', '5 वी': '5', '5TH STD': '5',
      // 6th / Class 6 / Class VI / Marathi
      '6': '6', '6TH': '6', 'SIXTH': '6', 'VI': '6', 'सहावी': '6', '६': '6', '६ वी': '6', '6 वी': '6', '6TH STD': '6',
      // 7th / Class 7 / Class VII / Marathi
      '7': '7', '7TH': '7', 'SEVENTH': '7', 'VII': '7', 'सातवी': '7', '७': '7', '७ वी': '7', '7 वी': '7', '7TH STD': '7',
      // 8th / Class 8 / Class VIII / Marathi
      '8': '8', '8TH': '8', 'EIGHTH': '8', 'VIII': '8', 'आठवी': '8', '८': '8', '८ वी': '8', '8 वी': '8', '8TH STD': '8',
      // 9th / Class 9 / Class IX / Marathi
      '9': '9', '9TH': '9', 'NINTH': '9', 'IX': '9', 'नववी': '9', '९': '9', '९ वी': '9', '9 वी': '9', '9TH STD': '9',
      // 10th / Class 10 / Class X / Marathi
      '10': '10', '10TH': '10', 'TENTH': '10', 'X': '10', 'दहावी': '10', '१०': '10', '१० वी': '10', '10 वी': '10', '10TH STD': '10',
      // 11th / Class 11 / Class XI / Marathi
      '11': '11', '11TH': '11', 'ELEVENTH': '11', 'XI': '11', 'अकरावी': '11', '११': '11', '११ वी': '11', '11 वी': '11', '11TH STD': '11',
      // 12th / Class 12 / Class XII / Marathi
      '12': '12', '12TH': '12', 'TWELFTH': '12', 'XII': '12', 'बारावी': '12', '१२': '12', '१२ वी': '12', '12 वी': '12', '12TH STD': '12',
      // Kindergarten / Nursery
      'JR KG': 'JR KG', 'JR. KG': 'JR KG', 'JUNIOR KG': 'JR KG', 'JUNIOR K.G.': 'JR KG', 'ज्युनियर के जी': 'JR KG', 'ज्युनियर केजी': 'JR KG',
      'SR KG': 'SR KG', 'SR. KG': 'SR KG', 'SENIOR KG': 'SR KG', 'SENIOR K.G.': 'SR KG', 'सिनियर के जी': 'SR KG', 'सिनियर केजी': 'SR KG',
      'NURSERY': 'NURSERY', 'नर्सरी': 'NURSERY', 'PLAYGROUP': 'PLAYGROUP', 'PRE-K': 'PRE-K'
    };

    if (classMapping[str]) {
      return classMapping[str];
    }

    // Fallback: strip extra punctuation and check again
    const cleanStr = str.replace(/[^A-Z0-9\u0900-\u097F]/g, ' ').replace(/\s+/g, ' ').trim();
    if (classMapping[cleanStr]) {
      return classMapping[cleanStr];
    }

    return str;
  };

  const setupObjectStores = (db) => {
    if (!db.objectStoreNames.contains(STUDENT_STORE)) {
      db.createObjectStore(STUDENT_STORE, { keyPath: "id" });
    }
    if (!db.objectStoreNames.contains(SCHOOL_STORE)) {
      db.createObjectStore(SCHOOL_STORE, { keyPath: "udiseNumber" });
    }
    if (!db.objectStoreNames.contains(ATTENDANCE_STORE)) {
      db.createObjectStore(ATTENDANCE_STORE, { autoIncrement: true });
    }
    if (!db.objectStoreNames.contains(DEFAULTSETTING_STORE)) {
      db.createObjectStore(DEFAULTSETTING_STORE, { keyPath: "id" });
    }
    if (!db.objectStoreNames.contains(INVENTORY_STORE)) {
      db.createObjectStore(INVENTORY_STORE, { keyPath: "key" });
    }
    if (!db.objectStoreNames.contains(LEAVING_CERTIFICATE_STORE)) {
      db.createObjectStore(LEAVING_CERTIFICATE_STORE, { keyPath: "serialNo" });
    }
    if (!db.objectStoreNames.contains(BONAFIDE_CERTIFICATE_STORE)) {
      db.createObjectStore(BONAFIDE_CERTIFICATE_STORE, { keyPath: "serialNo" });
    }
    if (!db.objectStoreNames.contains(KIRD_STORE)) {
      db.createObjectStore(KIRD_STORE, { keyPath: "id" });
    }
  };

  const initializeDB = () => {
    return new Promise((resolve, reject) => {
      const openRequest = () => {
        try {
          const request = indexedDB.open(DB_NAME, DB_VERSION);

          request.onerror = (event) => {
            event.preventDefault();
            const err = event.target.error;
            console.error("IndexedDB error:", err);

            // If browser has a database with a higher version than DB_VERSION (e.g., version 3 from previous testing)
            if (err && (err.name === 'VersionError' || err.code === 12 || (err.message && err.message.toLowerCase().includes('version')))) {
              console.warn(`IndexedDB version conflict detected (${err.message}). Deleting existing '${DB_NAME}' and recreating at version ${DB_VERSION}...`);
              try {
                const deleteReq = indexedDB.deleteDatabase(DB_NAME);
                deleteReq.onsuccess = () => {
                  console.log(`Database '${DB_NAME}' deleted successfully. Reopening fresh database...`);
                  try {
                    const retryReq = indexedDB.open(DB_NAME, DB_VERSION);
                    retryReq.onerror = (retryEvt) => {
                      retryEvt.preventDefault();
                      console.error("IndexedDB retry error:", retryEvt.target.error);
                      reject("Error opening IndexedDB");
                    };
                    retryReq.onsuccess = (retryEvt) => {
                      resolve(retryEvt.target.result);
                    };
                    retryReq.onupgradeneeded = (retryEvt) => {
                      setupObjectStores(retryEvt.target.result);
                    };
                  } catch (retryErr) {
                    console.error("Retry exception:", retryErr);
                    reject(retryErr);
                  }
                };
                deleteReq.onerror = (delErr) => {
                  console.error("Failed to delete conflicting IndexedDB:", delErr);
                  reject("Error opening IndexedDB");
                };
                deleteReq.onblocked = () => {
                  console.warn("IndexedDB deleteDatabase blocked. Please close any other open tabs of this app.");
                };
              } catch (delExc) {
                console.error("Exception deleting IndexedDB:", delExc);
                reject("Error opening IndexedDB");
              }
              return;
            }

            reject("Error opening IndexedDB");
          };

          request.onsuccess = (event) => {
            const db = event.target.result;
            resolve(db);
          };

          request.onupgradeneeded = (event) => {
            setupObjectStores(event.target.result);
          };
        } catch (err) {
          console.error("IndexedDB open threw synchronous error:", err);
          reject(err);
        }
      };

      openRequest();
    });
  };

  const clearIndexedDB = async () => {
    try {
      const db = await initializeDB();
      const allStores = [
        STUDENT_STORE,
        SCHOOL_STORE,
        ATTENDANCE_STORE,
        DEFAULTSETTING_STORE,
        INVENTORY_STORE,
        KIRD_STORE,
        LEAVING_CERTIFICATE_STORE,
        BONAFIDE_CERTIFICATE_STORE
      ];
      const validStores = allStores.filter((store) => db.objectStoreNames.contains(store));

      if (validStores.length === 0) return;

      const transaction = db.transaction(validStores, "readwrite");

      // Clear each store
      await Promise.all(
        validStores.map((storeName) => {
          try {
            return transaction.objectStore(storeName).clear();
          } catch (e) {
            console.warn(`Could not clear store ${storeName}:`, e);
            return Promise.resolve();
          }
        })
      );

      transaction.oncomplete = () => {
        console.log("All IndexedDB data cleared successfully.");
      };

      transaction.onerror = (e) => {
        console.error("Error clearing IndexedDB data:", e.target.error);
      };
    } catch (error) {
      console.error("Error initializing DB for clearing data:", error);
    }
  };
  const storeSchoolData = async (schoolData, selectedDept = null) => {
    try {
      const db = await initializeDB();
      const transaction = db.transaction(SCHOOL_STORE, "readwrite");
      const store = transaction.objectStore(SCHOOL_STORE);

      console.log("Storing school data in IndexedDB:", schoolData);

      let completeSchoolData = {
        udiseNumber: schoolData.udiseNumber || udiseNumber,
        ...schoolData,
        signature: schoolData.signature || "" // Make sure signature is included
      };

      if (selectedDept && schoolData.department && schoolData.department[selectedDept]) {
        const deptData = schoolData.department[selectedDept];
        completeSchoolData = {
          ...completeSchoolData,
          schoolName: deptData.schoolName || completeSchoolData.schoolName,
          schoolLogo: deptData.schoolLogo || completeSchoolData.schoolLogo,
          language: deptData.language || completeSchoolData.language || "English",
          address: deptData.address || completeSchoolData.address || "",
          taluka: deptData.taluka || completeSchoolData.taluka || "",
          jilha: deptData.jilha || completeSchoolData.jilha || "",
          email: deptData.email || completeSchoolData.email || "",
          boardName: deptData.boardName || completeSchoolData.boardName || "",
          boardType: deptData.boardType || completeSchoolData.boardType || "",
          madhyam: deptData.madhyam || completeSchoolData.madhyam || "",
          mobileNumber: deptData.mobileNumber || completeSchoolData.mobileNumber || "",
          sansthaName: deptData.sansthaName || completeSchoolData.sansthaName || "",
          schoolLogo2: deptData.schoolLogo2 || completeSchoolData.schoolLogo2 || "",
          signature: deptData.signature || completeSchoolData.signature || "",
          manyataKramank: deptData.manyataKramank || completeSchoolData.manyataKramank || "",
          indexNumber: deptData.indexNumber || completeSchoolData.indexNumber || "",
          schoolCode: deptData.schoolCode || completeSchoolData.schoolCode || "",
          sanlagnataKramank: deptData.sanlagnataKramank || completeSchoolData.sanlagnataKramank || "",
          state: deptData.state || completeSchoolData.state || "",
          telephoneNumber: deptData.telephoneNumber || completeSchoolData.telephoneNumber || "",
          department: selectedDept,
          isDepartmentData: true
        };
      }

      const request = store.put(completeSchoolData);

      request.onsuccess = () => {
        console.log("School data stored successfully");
      };

      request.onerror = (e) => {
        console.error("Error storing school data:", e.target.error);
      };
    } catch (error) {
      console.error("Error initializing DB for school data:", error);
    }
  };


  const storeStudentData = async (studentData) => {
    try {
      const db = await initializeDB();

      // Clear STUDENT_STORE first so old department data is deleted
      await new Promise((resolve, reject) => {
        const clearTransaction = db.transaction(STUDENT_STORE, "readwrite");
        const clearStore = clearTransaction.objectStore(STUDENT_STORE);
        const clearRequest = clearStore.clear();
        clearRequest.onsuccess = () => resolve();
        clearRequest.onerror = (e) => reject(e.target.error);
      });

      // Prepare student data - add unique IDs if they don't exist
      const preparedData = Object.entries(studentData).map(([key, student]) => {
        if (student === null) return null;

        // Trim all relevant fields
        const currentClass = (student.currentClass || "").trim();
        const division = (student.division || "").trim();
        const serialNo = (student.serialNo || "").toString().trim();
        const id = (student.id || "").trim();

        return {
          ...student,
          currentClass,
          division,
          serialNo,
          id: id || `${currentClass}-${division || ''}-${serialNo}`
        };
      }).filter(item => item !== null);

      // Process in batches of 100 records
      const BATCH_SIZE = 100;

      // Function to store a batch
      const storeBatch = (batch) => {
        return new Promise((resolve, reject) => {
          const transaction = db.transaction(STUDENT_STORE, "readwrite");
          const store = transaction.objectStore(STUDENT_STORE);

          transaction.oncomplete = () => resolve();
          transaction.onerror = (e) => reject(e.target.error);

          batch.forEach(student => {
            store.put(student);
          });
        });
      };

      for (let i = 0; i < preparedData.length; i += BATCH_SIZE) {
        const batch = preparedData.slice(i, i + BATCH_SIZE);
        await storeBatch(batch);
      }

      storeSerialNoSummary(preparedData);

      // console.log(`Successfully stored ${preparedData.length} student records in IndexedDB`);
      return true;
    } catch (error) {
      console.error("Error storing student data in IndexedDB:", error);
      return false;
    }
  };
  const storeKirdData = async (kirdData) => {
    try {
      const db = await initializeDB();
      const transaction = db.transaction(KIRD_STORE, "readwrite");
      const store = transaction.objectStore(KIRD_STORE);

      const request = store.put(kirdData); // Assuming kirdData has a unique id

      request.onsuccess = () => {
        console.log("Kird data stored successfully");
      };

      request.onerror = (e) => {
        console.error("Error storing kird data:", e.target.error);
      };
    } catch (error) {
      console.error("Error initializing DB for kird data:", error);
    }
  };


  const storeAttendanceData = async (attendanceData) => {
    try {
      const db = await initializeDB();
      const transaction = db.transaction(ATTENDANCE_STORE, "readwrite");
      const store = transaction.objectStore(ATTENDANCE_STORE);

      Object.keys(attendanceData).forEach((key) => {
        const attendanceRecord = attendanceData[key];
        const studentSerialNumber = key;

        store.put({
          srNo: studentSerialNumber, // Use srNo as the key
          Presenty: attendanceRecord // Store the attendance data
        }, studentSerialNumber); // Specify the key
      });
      transaction.oncomplete = () => {
      };
      transaction.onerror = (e) => {
        console.error("Error storing attendance data:", e.target.error);
      };
    } catch (error) {
      console.error("Error initializing DB for attendance data:", error);
    }
  };

  const storeSerialNoSummary = (studentData) => {
    const serialNoData = {};

    studentData.forEach((student) => {
      const currentClass = student.currentClass;
      const division = student.division;
      const serialNo = student.serialNo;

      if (!serialNoData[currentClass]) {
        serialNoData[currentClass] = {};
      }

      if (!serialNoData[currentClass][division]) {
        serialNoData[currentClass][division] = [];
      }

      serialNoData[currentClass][division].push(serialNo);
    });

    // Store summary in localStorage for quick access
    localStorage.setItem("serialNoData", JSON.stringify(serialNoData));
  };
  const storeDefaultSettingsData = async (defaultSettings) => {
    try {
      const db = await initializeDB();
      const transaction = db.transaction(DEFAULTSETTING_STORE, "readwrite");
      const store = transaction.objectStore(DEFAULTSETTING_STORE);

      // Prepare the data to be stored
      const settingsData = {
        id: 'defaultSettings', // Use a unique key for the settings
        defaultAdmissionClass: defaultSettings.defaultAdmissionClass,
        defaultCurrentClass: defaultSettings.defaultCurrentClass,
        defaultYear: defaultSettings.defaultYear,
        isCollege: defaultSettings.isCollege,
        isDean: defaultSettings.isDean,
        isPrincipal: defaultSettings.isPrincipal,
        isSchool: defaultSettings.isSchool,
      };

      const request = store.put(settingsData);
      request.onsuccess = () => {
      };

      request.onerror = (e) => {
        console.error("Error storing default settings data:", e.target.error);
      };
    } catch (error) {
      console.error("Error initializing DB for default settings data:", error);
    }
  };


  const storeInventoryData = async (inventoryData) => {
    try {
      console.log("inventoryData", inventoryData);

      const db = await initializeDB();
      console.log("IndexedDB initialized");

      const transaction = db.transaction(INVENTORY_STORE, "readwrite");
      console.log("Transaction created");

      const store = transaction.objectStore(INVENTORY_STORE);
      console.log("Object store retrieved");

      // Clear existing inventory data
      store.clear();
      console.log("Existing inventory data cleared");

      // Store inventory data
      Object.keys(inventoryData).forEach((key, index) => {
        store.put({ id: index + 1, key, value: inventoryData[key] });
        console.log(`Inventory data stored for key: ${key}`);
      });

      transaction.oncomplete = () => {
        console.log("Transaction completed");
      };

      transaction.onerror = (e) => {
        console.error("Error storing inventory data:", e.target.error);
      };
    } catch (error) {
      console.error("Error initializing DB for inventory data:", error);
    }
  };

  const storeAttachFeeData = async (attachFeeData) => {
    try {
      const db = await initializeDB();
      const transaction = db.transaction(KIRD_STORE, "readwrite");
      const store = transaction.objectStore(KIRD_STORE);

      // Clear existing attachFeeData data
      await store.clear();

      // Transform and store attachFeeData
      Object.keys(attachFeeData).forEach((key) => {
        const data = attachFeeData[key];
        const formattedData = {
          id: key, // Use the key as the id
          kirdType: data.kirdType,
          creditKhate: data.creditKhate,
          debitKhate: data.debitKhate,
          typeofattach: data.typeofattach
        };
        store.put(formattedData);
        console.log(`attachFeeData stored for key: ${key}`);
      });

      transaction.oncomplete = () => {
        console.log("Transaction completed for attachFeeData");
      };

      transaction.onerror = (e) => {
        console.error("Error storing attachFeeData data:", e.target.error);
      };
    } catch (error) {
      console.error("Error initializing DB for attachFeeData data:", error);
    }
  };




  const storeLeavingCertificateData = async (leavingCertificateData) => {
    try {
      const db = await initializeDB();
      const transaction = db.transaction(LEAVING_CERTIFICATE_STORE, "readwrite");
      const store = transaction.objectStore(LEAVING_CERTIFICATE_STORE);
      Object.keys(leavingCertificateData).forEach((serialNo) => {
        const data = leavingCertificateData[serialNo];
        store.put({ serialNo, ...data });
      });
      transaction.oncomplete = () => {
        console.log("Leaving certificate data stored successfully");
      };
      transaction.onerror = (e) => {
        console.error("Error storing leaving certificate data:", e.target.error);
      };
    } catch (error) {
      console.error("Error initializing DB for leaving certificate data:", error);
    }
  };

  const storeBonafideCertificateData = async (BonafideCertificateData) => {
    try {
      const db = await initializeDB();
      const transaction = db.transaction(BONAFIDE_CERTIFICATE_STORE, "readwrite");
      const store = transaction.objectStore(BONAFIDE_CERTIFICATE_STORE);
      Object.keys(BonafideCertificateData).forEach((serialNo) => {
        const data = BonafideCertificateData[serialNo];
        store.put({ serialNo, ...data });
      });
      transaction.oncomplete = () => {
        console.log("BonafideCertificateData certificate data stored successfully");
      };
      transaction.onerror = (e) => {
        console.error("Error storing BonafideCertificateData certificate data:", e.target.error);
      };
    } catch (error) {
      console.error("Error initializing DB for BonafideCertificateData certificate data:", error);
    }
  };


  // Add new useEffect for fetching departments
  useEffect(() => {
    const fetchDepartmentOptions = async () => {
      if (udiseNumber) {
        try {
          const departmentResponse = await fetch(
            `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${normalizeUdise(udiseNumber)}/department.json`
          );
          const departmentData = await departmentResponse.json();

          if (departmentResponse.ok && departmentData) {
            const departments = Object.keys(departmentData);
            setDepartmentOptions(departments);
            if (departments.length === 1) {
              setDepartment(departments[0]);
            } else {
              setDepartment('');
            }
          } else {
            setDepartmentOptions([]);
            setDepartment('');
          }
        } catch (error) {
          console.error("Error fetching department options:", error);
          setDepartmentOptions([]);
          setDepartment('');
        }
      } else {
        setDepartmentOptions([]);
        setDepartment('');
      }
    };

    fetchDepartmentOptions();
  }, [udiseNumber]);


  useEffect(() => {
    const fetchUdiseOptions = async () => {
      if (mobileNumber.length === 10) {
        try {
          const userResponse = await fetch(
            `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/user/${mobileNumber}.json`
          );
          const userData = await userResponse.json();

          if (userResponse.ok && userData) {
            const udiseList = [];

            if (userData.udiseNumber) {
              udiseList.push(normalizeUdise(userData.udiseNumber));
            }

            const udiseOptionsFromData = Object.values(userData)
              .filter((entry) => entry.udiseNumber)
              .map((entry) => normalizeUdise(entry.udiseNumber));

            const allUdiseOptions = [...new Set([...udiseList, ...udiseOptionsFromData])];
            setUdiseOptions(allUdiseOptions);

            if (allUdiseOptions.length === 1) {
              setUdiseNumber(allUdiseOptions[0]);
            }
          } else {
            setUdiseOptions([]);
          }
        } catch (error) {
          console.error("Error fetching UDISE options:", error);
          setUdiseOptions([]);
        }
      } else {
        setUdiseOptions([]);
      }
    };

    fetchUdiseOptions();
  }, [mobileNumber]);

  const handleDepartmentChange = async (e) => {
    const selectedDept = e.target.value;
    setDepartment(selectedDept);

    try {
      // Fetch the complete school data
      const schoolResponse = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${String(udiseNumber)}/schoolData.json`
      );
      const schoolData = await schoolResponse.json();

      if (schoolResponse.ok && schoolData) {
        // Store only the selected department's data
        await storeSchoolData(schoolData, selectedDept);

        // Update UI with department-specific data
        if (selectedDept && schoolData.department && schoolData.department[selectedDept]) {
          const deptData = schoolData.department[selectedDept];
          setSchoolName(deptData.schoolName || schoolData.schoolName);
          setSchoolLogo(deptData.schoolLogo || schoolData.schoolLogo);
          setschoollanguage(deptData.language || schoolData.language || "English");
        } else {
          // Fallback to base school data if no department selected or no department data
          setSchoolName(schoolData.schoolName);
          setSchoolLogo(schoolData.schoolLogo);
          setschoollanguage(schoolData.language || "English");
        }
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
    }
  };

  const fetchSchoolData = async () => {
    await clearIndexedDB();
    if (mobileNumber.length === 10 && udiseNumber) {
      try {
        let schoolDataToStore = null;

        // 1. Try to fetch department data first if selected
        if (department) {
          const deptResponse = await fetch(
            `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData/department/${department}.json`
          );

          if (deptResponse.ok) {
            const deptData = await deptResponse.json();
            if (deptData) {
              schoolDataToStore = {
                udiseNumber,
                schoolName: deptData.schoolName || "",
                address: deptData.address || "",
                taluka: deptData.taluka || "",
                jilha: deptData.jilha || "",
                email: deptData.email || "",
                boardName: deptData.boardName || "",
                boardType: deptData.boardType || "",
                madhyam: deptData.madhyam || "",
                mobileNumber: deptData.mobileNumber || "",
                sansthaName: deptData.sansthaName || "",
                schoolLogo: deptData.schoolLogo || "",
                schoolLogo2: deptData.schoolLogo2 || "",
                signature: deptData.signature || "",
                manyataKramank: deptData.manyataKramank || "",
                indexNumber: deptData.indexNumber || "",
                schoolCode: deptData.schoolCode || "",
                sanlagnataKramank: deptData.sanlagnataKramank || "",
                state: deptData.state || "",
                telephoneNumber: deptData.telephoneNumber || "",
                department: department,
                isDepartmentData: true
              };

              // Update UI
              setSchoolName(deptData.schoolName || "");
              setSchoolLogo(deptData.schoolLogo || "");
              setschoollanguage(deptData.language || "English");
            }
          }
        }

        // 2. If no department data, fetch main school data
        if (!schoolDataToStore) {
          const schoolResponse = await fetch(
            `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`
          );

          if (schoolResponse.ok) {
            const schoolData = await schoolResponse.json();
            if (schoolData) {
              schoolDataToStore = {
                udiseNumber,
                schoolName: schoolData.schoolName || "",
                address: schoolData.address || "",
                taluka: schoolData.taluka || "",
                jilha: schoolData.jilha || "",
                email: schoolData.email || "",
                boardName: schoolData.boardName || "",
                boardType: schoolData.boardType || "",
                madhyam: schoolData.madhyam || "",
                mobileNumber: schoolData.mobileNumber || "",
                sansthaName: schoolData.sansthaName || "",
                schoolLogo: schoolData.schoolLogo || "",
                schoolLogo2: schoolData.schoolLogo2 || "",
                signature: schoolData.signature || "", // Add signature field

                manyataKramank: schoolData.manyataKramank || "",
                indexNumber: schoolData.indexNumber || "",
                schoolCode: schoolData.schoolCode || "",
                sanlagnataKramank: schoolData.sanlagnataKramank || "",
                state: schoolData.state || "",
                telephoneNumber: schoolData.telephoneNumber || "",
                department: 'Main',
                isDepartmentData: false
              };

              // Update UI
              setSchoolName(schoolData.schoolName || "");
              setSchoolLogo(schoolData.schoolLogo || "");
              setschoollanguage(schoolData.language || "English");
            }
          }
        }

        // 3. Store the data if we have it
        if (schoolDataToStore) {
          console.log("Storing school data:", schoolDataToStore);
          await storeSchoolData(schoolDataToStore);
        } else {
          console.warn("No school data found for UDISE:", udiseNumber);
          setSchoolName("");
          setSchoolLogo("");
        }

      } catch (error) {
        console.error("Error fetching school data:", error);
        setSchoolName("");
        setSchoolLogo("");
      }
    } else {
      setSchoolName("");
      setSchoolLogo("");
    }
  };

  useEffect(() => {
    if (udiseNumber) {
      fetchSchoolData();
    }
  }, [udiseNumber, department]);

  const createClassDiv = async () => {
    try {
      const db = await initializeDB();
      const transaction = db.transaction(STUDENT_STORE, "readonly");
      const store = transaction.objectStore(STUDENT_STORE);

      // Create a promise to handle the request
      const students = await new Promise((resolve, reject) => {
        const request = store.getAll(); // Fetch all student data

        request.onsuccess = (event) => {
          resolve(event.target.result); // Resolve with the result
        };

        request.onerror = (event) => {
          reject("Error fetching students: " + event.target.error); // Reject on error
        };
      });

      const classDiv = {};

      students.forEach(student => {
        const { currentClass, division } = student;

        if (!classDiv[currentClass]) {
          // If no division, set to true; if division exists, create an object
          classDiv[currentClass] = division ? { [division]: true } : true;
        } else {
          // If class already exists, check if it's an object
          if (typeof classDiv[currentClass] === 'object') {
            // If division exists, add it to the existing object
            if (division) {
              classDiv[currentClass][division] = true; // Add division to existing class
            }
          } else {
            // If class is true (no divisions), convert it to an object
            if (division) {
              classDiv[currentClass] = { [division]: true }; // Create an object with the division
            }
          }
        }
      });

      // Store the organized classDiv in localStorage
      localStorage.setItem("classDiv", JSON.stringify(classDiv));
    } catch (error) {
      console.error("Error creating classDiv:", error);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setSavingData(true);
    try {
      const userResponse = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/user/${mobileNumber}.json`
      );
      const userData = await userResponse.json();

      if (!userResponse.ok || !userData) {
        setErrorMessage(
          language === "English"
            ? "Mobile number is not registered."
            : "मोबाईल नंबर नोंदणीकृत नाही."
        );
        setSavingData(false);
        return;
      }

      // Normalize the input UDISE number
      const normalizedInputUdise = normalizeUdise(udiseNumber);

      // Find matching user data by comparing normalized UDISE numbers
      const selectedUserData =
        Object.values(userData).find((data) =>
          normalizeUdise(data.udiseNumber) === normalizedInputUdise
        ) ||
        (normalizeUdise(userData.udiseNumber) === normalizedInputUdise ? userData : null);

      if (!selectedUserData) {
        setErrorMessage(
          language === "English"
            ? "Mobile number is incorrect or not found."
            : "मोबाइल नंबर अयोग्य किंवा सापडला नाही."
        );
        setSavingData(false);
        return;
      }

      if (selectedUserData.password !== password) {
        setErrorMessage(
          language === "English" ? "Incorrect password." : "अयोग्य पासवर्ड."
        );
        setSavingData(false);
        return;
      }

      // Fetch admin data to check plan status
      const adminResponse = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/Admin/${normalizedInputUdise}.json`
      );
      const adminData = await adminResponse.json();

      if (!adminResponse.ok || !adminData) {
        setErrorMessage(
          language === "English"
            ? "Unable to verify account status. Please contact support."
            : "खाते स्थिती सत्यापित करण्यात अक्षम. कृपया समर्थनाशी संपर्क साधा."
        );
        setSavingData(false);
        return;
      }

      // Check if account is active
      if (adminData.userStatus?.toLowerCase() !== "active") {
        alert(
          language === "English"
            ? "Your account is not active. Please contact our team to activate your plan."
            : "तुमचे खाते सक्रिय नाही. कृपया आमच्या टीमशी संपर्क साधा."
        );

        // console.log("normalizedInputUdise",normalizedInputUdise);

        // navigate("/plans-for-user", { 
        //   state: { 
        //     udiseNumber: normalizedInputUdise 
        //   }
        // });
        setSavingData(false);
        return;
      }


      // Fetch department classes from Firebase
      let allowedClasses = [];
      if (department) {
        // Specific department selected 
        const departmentResponse = await fetch(
          `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${normalizedInputUdise}/department/${department}.json`
        );
        if (!departmentResponse.ok) {
          throw new Error(`Failed to fetch data for department: ${department}`);
        }
        const departmentData = await departmentResponse.json();

        if (departmentData && typeof departmentData === 'object') {
          allowedClasses = Object.keys(departmentData).map((classKey) =>
            normalizeClassName(classKey)
          ).filter(className => className); // Filter out empty class names
          console.log(`Classes for department ${department}:`, allowedClasses);
        }
      } else if (department === "") {
        // "All" selected - fetch all departments
        const allDepartmentsResponse = await fetch(
          `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${normalizedInputUdise}/department.json`
        );
        if (!allDepartmentsResponse.ok) {
          throw new Error('Failed to fetch all departments');
        }
        const allDepartmentsData = await allDepartmentsResponse.json();

        if (allDepartmentsData && typeof allDepartmentsData === 'object') {
          // Collect all unique classes from all departments
          const allClasses = new Set();
          Object.values(allDepartmentsData).forEach((deptData) => {
            if (deptData && typeof deptData === 'object') {
              Object.keys(deptData).forEach((classKey) => {
                const normalizedClass = normalizeClassName(classKey);
                if (normalizedClass) allClasses.add(normalizedClass);
              });
            }
          });
          allowedClasses = Array.from(allClasses);
          console.log('Classes for all departments:', allowedClasses);
        }
      }

      // Check if plan has expired
      const currentDate = new Date();
      const deactivationDate = new Date(adminData.deactivationDate);

      if (currentDate > deactivationDate) {
        // Update user status to Deactive in Admin node
        await fetch(
          `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/Admin/${normalizedInputUdise}/userStatus.json`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify("Deactive"),
          }
        );

        alert(
          language === "English"
            ? "Your free trial has expired. Please contact our team to activate your plan."
            : "तुमची विनामूल्य चाचणी कालबाह्य झाली आहे. कृपया आमच्या टीमशी संपर्क साधा."
        );
        setSavingData(false);
        return;
      }

      // Fetch and store student data
      const schoolResponse = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${normalizedInputUdise}/studentData.json`
      );
      const studentData = await schoolResponse.json();
      if (studentData && typeof studentData === 'object') {
        // Filter student data based on allowed classes if any (specific department or All)
        let filteredStudentData = studentData;
        if (allowedClasses.length > 0) {
          filteredStudentData = Object.fromEntries(
            Object.entries(studentData).filter(([key, student]) => {
              if (student === null) return false;
              // Normalize student.currentClass to match allowedClasses
              const studentClass = normalizeClassName(student.currentClass);
              return allowedClasses.includes(studentClass);
            })
          );
        }




        // Log the number of students to be stored for debugging
        console.log(`Storing ${Object.keys(filteredStudentData).length} students in IndexedDB`);

        // Store filtered student data in IndexedDB
        const storeSuccess = await storeStudentData(filteredStudentData);
        if (!storeSuccess) {
          throw new Error('Failed to store student data in IndexedDB');
        }
        await createClassDiv();
      }


      // Store login count and timestamp
      const loginCountRef = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolLogin/${normalizedInputUdise}`;
      const currentDate2 = new Date().toISOString();
      console.log("loginCountRef", loginCountRef);

      // Fetch current login count
      const loginCountResponse = await fetch(`${loginCountRef}.json`);
      const loginCountData = await loginCountResponse.json();
      let loginCount = 1; // Default to 1 if no previous logins

      console.log("loginCountData", loginCountData);

      // Check if there are existing login counts
      if (loginCountData) {
        // Extract the keys and convert them to numbers
        const existingCounts = Object.keys(loginCountData).map(Number);

        // Find the maximum existing count
        const maxCount = Math.max(...existingCounts);

        // Increment the maximum count by 1
        loginCount = maxCount + 1;
      }

      // Store the new login count and timestamp
      await fetch(`${loginCountRef}/${loginCount}.json`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ timestamp: currentDate2 }),
      });

      const defaultSettingsResponse = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${normalizedInputUdise}/defaultSettings.json`
      );
      const defaultSettingsData = await defaultSettingsResponse.json();

      if (defaultSettingsResponse.ok && defaultSettingsData) {
        await storeDefaultSettingsData(defaultSettingsData);
      }

      const AttendanceResponse = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${normalizedInputUdise}/Attendance.json`
      );
      const AttendanceData = await AttendanceResponse.json();

      if (AttendanceResponse.ok && AttendanceData) {
        await storeAttendanceData(AttendanceData);
      }

      const inventoryResponse = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${normalizedInputUdise}/inventory.json`
      );
      const inventoryData = await inventoryResponse.json();

      if (inventoryResponse.ok && inventoryData) {
        try {
          await storeInventoryData(inventoryData);
        } catch (error) {
          console.error("Error storing inventory data in IndexedDB:", error);
        }
      }

      const storeAttachFeeData = async (attachFeeData) => {
        try {
          const db = await initializeDB();
          const transaction = db.transaction(KIRD_STORE, "readwrite");
          const store = transaction.objectStore(KIRD_STORE);

          // Clear existing attachFeeData data
          await store.clear();

          // Transform and store attachFeeData
          Object.keys(attachFeeData).forEach((key) => {
            const data = attachFeeData[key];
            const formattedData = {
              id: key, // Use the key as the id
              kirdType: data.kirdType,
              creditKhate: data.creditKhate,
              debitKhate: data.debitKhate,
              typeofattach: data.typeofattach
            };
            store.put(formattedData);
            console.log(`attachFeeData stored for key: ${key}`);
          });

          transaction.oncomplete = () => {
            console.log("Transaction completed for attachFeeData");
          };

          transaction.onerror = (e) => {
            console.error("Error storing attachFeeData data:", e.target.error);
          };
        } catch (error) {
          console.error("Error initializing DB for attachFeeData data:", error);
        }
      };

      // In your fetch logic, call storeAttachFeeData with the fetched data
      const attachFeeResponse = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/kirdWithFeeattach.json`
      );
      const attachFeedata = await attachFeeResponse.json();

      if (attachFeeResponse.ok && attachFeedata) {
        await storeAttachFeeData(attachFeedata);
      }



      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/leavedStd.json`
      );
      const leavingCertificateData = await response.json();
      if (response.ok && leavingCertificateData) {
        await storeLeavingCertificateData(leavingCertificateData);
      }

      const responseBona = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/BonafideStd.json`
      );
      const BonafideCertificateData = await responseBona.json();
      if (responseBona.ok && BonafideCertificateData) {
        await storeBonafideCertificateData(BonafideCertificateData);
      }

      const selectedPages = selectedUserData.selectedPages || [];
      const hu = CryptoJS.SHA256(String(selectedUserData.udiseNumber)).toString();
      const userStatus2 = selectedUserData.status;
      const editable = selectedUserData.editable || false;

      // Store essential data in localStorage
      localStorage.setItem("hu", hu);
      localStorage.setItem("udiseNumber", normalizedInputUdise);
      localStorage.setItem("language", language);
      localStorage.setItem("userStatus", userStatus2);
      localStorage.setItem("mobile", mobileNumber);
      localStorage.setItem("selectedPages", JSON.stringify(selectedPages));
      localStorage.setItem("department", department === "" ? "All" : department);  // New
      localStorage.setItem("editable", String(editable));
      localStorage.setItem("role", selectedUserData.role || (userStatus2 === "DKglzhgYFYTDT141414HGCkkgfs22117785YFUTFybnujghhgtghghYFYVNOmC234567Omgkysfgvghyfjhyfvv56764" ? "admin" : "teacher"));
      localStorage.setItem("assignedclass", JSON.stringify(selectedUserData.assignedclass || {}));
      localStorage.setItem("userName", selectedUserData.name || "");
      if (selectedUserData.schoolName) {
        localStorage.setItem("schoolName", selectedUserData.schoolName);
      }
      if (selectedUserData.superAdminNumber || selectedUserData.mobileNumber) {
        localStorage.setItem("superAdminNumber", selectedUserData.superAdminNumber || selectedUserData.mobileNumber);
      }


      setSavingData(false);
      navigate("/home");
    } catch (error) {
      console.error("Error logging in:", error);
      setErrorMessage(
        language === "English"
          ? "An error occurred while logging in. Please try again later."
          : "लॉगिन करताना त्रुटी आली. कृपया नंतर पुन्हा प्रयत्न करा."
      );
      setSavingData(false);
    }
  };


  const containerStyle = {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: '#f9f6f0',
    backgroundImage: `url(${schoolImage})`,
    backgroundPosition: 'bottom left',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% auto', /* Make it scale across the full width */
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: '"Georgia", serif',
  };

  const navStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1rem 4rem', // Reduced vertical padding since logo is bigger
    zIndex: 10,
    backgroundColor: '#f9f6f0',
    borderBottom: '1px solid #ddd',
  };

  const logoStyle = {
    fontSize: '3rem', // Larger to match the target
    fontWeight: 'bold',
    fontFamily: '"Georgia", serif', // Added serif font to match target
    letterSpacing: '-1px', // Tighten the letters slightly like the target
  };

  const logoVedStyle = {
    color: '#b22222', // Deeper, richer red matching target logo
  };
  
  const logoGurukulStyle = {
    color: '#1a5c3a', // Deeper, richer green matching target logo
  };

  const navLinksStyle = {
    fontSize: '0.85rem',
    letterSpacing: '3px',
    color: '#777',
    textTransform: 'uppercase',
    fontFamily: 'sans-serif',
    fontWeight: '600'
  };

  const mainAreaStyle = {
    display: 'flex',
    flex: '1',
    flexDirection: 'row',
    marginTop: '7.5rem', // Increased to account for larger navbar
    zIndex: 5,
    marginBottom: '4rem',
  };

  const leftContentStyle = {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    paddingLeft: '6rem',
    paddingTop: '5rem',
  };

  const welcomeTextContainer = {
    position: 'relative',
    zIndex: 2,
    padding: '2rem 4rem 2rem 1rem',
    marginLeft: '-1rem', // offset the padding
    background: 'radial-gradient(ellipse at center left, rgba(249, 246, 240, 0.9) 0%, rgba(249, 246, 240, 0.6) 45%, rgba(249, 246, 240, 0) 80%)',
  };

  const welcomeLineStyle = {
    width: '45px',
    height: '2px',
    backgroundColor: '#8c2c36',
    marginBottom: '1rem',
    boxShadow: '0 0 10px rgba(255,255,255,0.8)'
  };

  const welcomeToStyle = {
    fontSize: '2.2rem',
    color: '#444',
    marginBottom: '0',
    fontWeight: 'normal',
    textShadow: '1px 1px 0 #f9f6f0, -1px -1px 0 #f9f6f0, 1px -1px 0 #f9f6f0, -1px 1px 0 #f9f6f0, 0 4px 15px rgba(255,255,255,1)',
  };

  const vedGurukulTitleStyle = {
    fontSize: '5.5rem',
    fontWeight: 'bold',
    margin: '0',
    lineHeight: '1.1',
    textShadow: '2px 2px 0 #f9f6f0, -2px -2px 0 #f9f6f0, 2px -2px 0 #f9f6f0, -2px 2px 0 #f9f6f0, 0 8px 25px rgba(255,255,255,1)',
  };

  const subtitleStyle = {
    fontSize: '0.95rem',
    letterSpacing: '3px',
    color: '#555',
    marginTop: '1.5rem',
    textTransform: 'uppercase',
    fontFamily: 'sans-serif',
    fontWeight: 'bold',
    textShadow: '1px 1px 0 #f9f6f0, -1px -1px 0 #f9f6f0, 0 2px 10px rgba(255,255,255,0.9)',
  };

  const rightContentStyle = {
    flex: '0.8',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10,
    paddingRight: '6rem',
  };

  const formCardStyle = {
    background: '#ffffff',
    borderRadius: '16px',
    boxShadow: '-8px -8px 0px #8c2c36, 0 15px 40px rgba(0, 0, 0, 0.1)',
    padding: '3.5rem 3rem',
    width: '100%',
    maxWidth: '500px',
  };
  
  const titleStyle = {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    color: '#8c2c36',
    marginBottom: '2.5rem',
    textAlign: 'center',
  };

  const schoolNameStyle = {
    fontSize: '1.2rem',
    color: '#385c49',
    marginBottom: '1.5rem',
    textAlign: 'center',
    fontWeight: 'bold',
  };

  const inputContainerStyle = {
    marginBottom: '1.5rem',
    position: 'relative'
  };

  const labelStyle = {
    display: 'block',
    marginBottom: '0.6rem',
    color: '#333',
    fontWeight: 'bold',
    fontSize: '1rem',
    fontFamily: 'sans-serif'
  };

  const inputStyle = {
    width: '100%',
    padding: '0.9rem',
    paddingLeft: '2.8rem',
    borderRadius: '8px',
    border: '1px solid #ccc',
    transition: 'all 0.3s ease',
    fontSize: '1rem',
    outline: 'none',
    boxSizing: 'border-box',
    fontFamily: 'sans-serif',
    backgroundColor: '#fff'
  };
  
  const iconStyle = {
    position: 'absolute',
    left: '1rem',
    bottom: '0.95rem',
    width: '18px',
    height: '18px',
    color: '#888'
  };

  const buttonStyle = {
    width: '100%',
    padding: '0.9rem 1rem',
    borderRadius: '8px',
    backgroundColor: '#8c2c36',
    color: 'white',
    border: 'none',
    fontSize: '1.1rem',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    marginTop: '1.5rem',
    fontFamily: '"Georgia", serif'
  };

  const errorStyle = {
    color: '#ef4444',
    marginTop: '0.5rem',
    fontSize: '0.875rem',
    fontFamily: 'sans-serif'
  };

  const linkContainerStyle = {
    textAlign: 'center',
    marginTop: '1.5rem',
    fontFamily: 'sans-serif',
    fontSize: '0.95rem',
    color: '#555'
  };

  const linkStyle = {
    color: '#345e48',
    textDecoration: 'underline',
    fontWeight: 'bold',
    marginLeft: '0.3rem',
  };
  
  const forgetLinkStyle = {
    color: '#345e48',
    textDecoration: 'underline',
    fontWeight: 'bold',
    display: 'block',
    marginTop: '1rem',
  };

  const footerStyle = {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'space-between',
    padding: '1.5rem 4rem',
    fontSize: '0.8rem',
    color: '#777',
    fontFamily: 'sans-serif',
    zIndex: 10,
    borderTop: '1px solid rgba(0,0,0,0.05)',
  };

  const footerRightStyle = {
    display: 'flex',
    alignItems: 'center',
    letterSpacing: '1px',
    textTransform: 'uppercase'
  };
  
  const footerLineStyle = {
    width: '50px',
    height: '1px',
    backgroundColor: '#8c2c36',
    marginRight: '1rem'
  };

  return (
    <div style={containerStyle} className="login-container">
      <style>
        {`
        .login-container {
          box-sizing: border-box;
        }

        @media (max-width: 1024px) {
          .main-area {
            flex-direction: column !important;
            padding: 2rem 1.5rem !important;
            margin-top: 6rem !important;
          }
          
          .left-content {
            padding-left: 2rem !important;
            padding-right: 2rem !important;
            margin-bottom: 3rem;
            align-items: center;
            text-align: center;
          }

          .nav-links {
            display: none !important;
          }
          
          .login-footer {
            flex-direction: column;
            gap: 1rem;
            text-align: center;
            align-items: center;
            position: relative !important;
          }

          .right-content {
             padding-right: 0 !important;
             width: 100%;
          }
        }

        /* Prevent autofill styling from turning blue */
        input:-webkit-autofill,
        input:-webkit-autofill:hover, 
        input:-webkit-autofill:focus, 
        input:-webkit-autofill:active {
            -webkit-box-shadow: 0 0 0 30px white inset !important;
            -webkit-text-fill-color: black !important;
        }

        input:focus, select:focus {
          border-color: #8c2c36 !important;
          box-shadow: 0 0 0 2px rgba(140, 44, 54, 0.1) !important;
        }

        button:hover {
          background-color: #72232b !important;
          transform: translateY(-1px);
        }
      `}
      </style>

      {savingData && <img width={'100px'} style={{ zIndex: '99999', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} className="registerLoading" src={loadingspinner} alt="Loading" />}

      {/* Top Navbar */}
      <div style={navStyle}>
        <div style={{ ...logoStyle, display: 'flex', alignItems: 'center', gap: '18px' }}>
          <img src={mainLogo} alt="VedGurukul Logo" style={{ height: '80px', borderRadius: '50%', boxShadow: '0 2px 10px rgba(0,0,0,0.15)' }} />
          <div>
            <span style={logoVedStyle}>Ved</span><span style={logoGurukulStyle}>Gurukul</span>
          </div>
        </div>
        <div style={navLinksStyle} className="nav-links">
          EDUCATION &nbsp;&nbsp;|&nbsp;&nbsp; PEOPLE &nbsp;&nbsp;|&nbsp;&nbsp; PROGRESS
        </div>
      </div>

      {/* Main Content */}
      <div style={mainAreaStyle} className="main-area">
        
        {/* Left Side (Welcome Text) */}
        <div style={leftContentStyle} className="left-content">

        </div>

        {/* Right Side (Login Form) */}
        <div style={rightContentStyle} className="right-content">
          <div style={formCardStyle}>
            <h1 style={titleStyle}>{language === 'English' ? 'School Login' : 'स्कूल लॉगिन'}</h1>

            {schoolName && <div style={schoolNameStyle}>{schoolName}</div>}

            <form onSubmit={handleLogin}>
              <div style={inputContainerStyle}>
                <label style={labelStyle} htmlFor="mobileNumber">
                  {language === 'English' ? 'Mobile Number:' : 'मोबाईल नंबर:'}
                </label>
                {/* Hollow Mobile SVG Icon */}
                <svg style={iconStyle} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
                  <line x1="12" y1="18" x2="12.01" y2="18"></line>
                </svg>
                <input
                  style={inputStyle}
                  maxLength={10}
                  type="text"
                  id="mobileNumber"
                  name="mobileNumber"
                  value={mobileNumber}
                  onChange={e => setMobileNumber(e.target.value)}
                  autoComplete="off"
                />
              </div>
              
              {udiseOptions.length > 1 && (
                <div style={inputContainerStyle}>
                  <label style={labelStyle}>UDISE Number:</label>
                  <svg style={iconStyle} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
                  </svg>
                  <select
                    style={{...inputStyle, paddingLeft: '2.8rem'}}
                    value={udiseNumber}
                    onChange={(e) => setUdiseNumber(e.target.value)}
                    required
                  >
                    <option value="">Select UDISE Number</option>
                    {udiseOptions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              
              {departmentOptions.length > 0 && (
                <div style={inputContainerStyle}>
                  <label style={labelStyle} htmlFor="department">
                    {language === "English" ? "Department:" : "विभाग:"}
                  </label>
                  <svg style={iconStyle} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="2" y1="12" x2="22" y2="12"></line>
                    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                  </svg>
                  <select
                    style={{...inputStyle, paddingLeft: '2.8rem'}}
                    id="department"
                    value={department}
                    onChange={handleDepartmentChange}
                    required
                  >
                    <option value="" disabled hidden>
                      {language === "English" ? "Select Department" : "विभाग निवडा"}
                    </option>
                    {departmentOptions.map((dept) => (
                      <option key={dept} value={dept}>
                        {dept}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              <div style={inputContainerStyle}>
                <label style={labelStyle} htmlFor="password">
                  {language === 'English' ? 'Password:' : 'पासवर्ड:'}
                </label>
                {/* Hollow Lock SVG Icon */}
                <svg style={iconStyle} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </svg>
                <input
                  style={inputStyle}
                  type="password"
                  id="password"
                  name="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  autoComplete="new-password"
                />
              </div>

              {errorMessage && <div style={errorStyle}>{errorMessage}</div>}

              <button style={buttonStyle} type="submit">
                {language === 'English' ? 'Login' : 'लॉगिन'}
              </button>

              <div style={linkContainerStyle}>
                {language === 'English' ? 'Not Registered Yet? ' : 'अद्याप नोंदणी झाली नाही? '}
                <Link style={linkStyle} to="/school-register">
                  {language === 'English' ? 'Register' : 'नोंदणी करा'}
                </Link>
                
                <Link style={forgetLinkStyle} to="/forget-password">
                  {language === 'English' ? 'Forgot Password?' : 'पासवर्ड विसरलात?'}
                </Link>
              </div>
            </form>
          </div>
        </div>

      </div>

      {/* Footer */}
      <div style={footerStyle} className="login-footer">
        <div>Copyright © 2025 VedGurukul Software</div>
        <div style={footerRightStyle}>
          <div style={footerLineStyle}></div>
          NURTURING TODAY FOR TOMORROW
        </div>
      </div>
    </div>
  );
}

export default LoginForm;